import { metadataData } from './data'
import { getMetadata } from './getMetadata'

export const metadata = getMetadata(metadataData)
